import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SpedizioniService {

    constructor(private http: HttpClient) { }

    getPublicProvince(): Observable<any[]> {
        return this.http
            .get<any[]>(environment.apiUrl + "public/cantine/province/")
            .pipe(
                map((response) => {
                    return response;
                })
            );
    }

    getPublicCitta(sigla: string): Observable<any[]> {
        return this.http
            .get<any[]>(environment.apiUrl + "public/cantine/citta/" + sigla + "/")
            .pipe(
                map((response) => {
                    return response;
                })
            );
    }

    getPublicZip(istat: string): Observable<any[]> {
        return this.http
            .get<any[]>(environment.apiUrl + "public/cantine/zipcode/" + istat + "/")
            .pipe(
                map((response) => {
                    return response;
                })
            );
    }

}
